import { useTranslation } from "react-i18next";
import { ScreeningPscInspection } from "../../types/Screening";
import dayjs from "dayjs";

export const ScreeningPscDurationBody = (item: ScreeningPscInspection) => {
    const { t } = useTranslation("locale");

    if (!item.released_date) {
        return <p className="light-text">{t("psc.na")}</p>;
    }

    const duration = dayjs(item.released_date * 1000).diff(
        item.date * 1000,
        "days"
    );

    if (duration < 0) {
        return <p className="light-text">{t("psc.na")}</p>;
    }

    return <p>{`${duration} ${t(duration === 1 ? "psc.day" : "psc.days")}`}</p>;
};
